import * as api from "../API/index";

// verify otp
export const verifyOTP = async (bodyData) => {
  try {
    const res = await api.verify_otp(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// resend otp
export const resendOTP = async (bodyData) => {
  try {
    const res = await api.resend_otp(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// add visitor data
export const addVisitor = async (bodyData) => {
  try {
    const res = await api.add_visitor(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// get jointer data
export const getJointerDetails = async (params) => {
  try {
    const res = await api.get_jointer(params);
    return res;
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }
    return error.response?.data || error;
  }
};

export const downloadQR = async (id) => {
  try {
    const res = await api.download_qr(id);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download QR code. Please try again.",
      }
    );
  }
};


export const downloadAuthorizationQR = async (id) => {
  try {
    const res = await api.download__authorization_qr(id);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download QR code. Please try again.",
      }
    );
  }
};

export const visitorLogout = async (params) => {
  try {
    const res = await api.visitor_logout(params);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};